import React from 'react';

import { Modal } from '@eika/modal';

type ModalProps = React.ComponentProps<typeof Modal>;

const KortbetjeningModal = ({ appNamespace = '', ...rest }: ModalProps) => (
    <Modal appNamespace={appNamespace} {...rest} />
);

export default KortbetjeningModal;
